module.exports = __webpack_public_path__ + "f33611bff5abfdb21347a4be0cd43a8f.pdf";